import { inject } from '@angular/core';
import { CanMatchFn, Route, Router } from '@angular/router';
import { TenantService } from '@lib/services/tenant.service';

let  tenantKey ='tenant0_api'

type AuthGuardOptions = {
    requiresAuthentication: boolean;
};

const defaultAuthGuardOptions = (): AuthGuardOptions => ({
    requiresAuthentication: true,
});
export const authGuard = (options: AuthGuardOptions = defaultAuthGuardOptions()): CanMatchFn => {
    return (route: Route,segments) => {
        const tenantService = inject(TenantService);
        const router = inject(Router);
       
        // Defensive check
        if (segments[1]?.path.includes('_api') || tenantService.getTenantKey()) {
            tenantKey = tenantService.getTenantKey() || segments[1]?.path
        }
        
        if (options.requiresAuthentication === !!localStorage.getItem('accessToken')) {
            return true;
        }

        return options.requiresAuthentication ? router.createUrlTree([`/auth/${tenantKey}/login`]) : router.createUrlTree(['/']);
    };
};